export function getLineStatusChipStyle(status: string, isDark = false): { backgroundColor: string; color: string } {
    switch (status.toLowerCase()) {
        case "invoiced":
            return isDark
                ? { backgroundColor: "rgba(76, 175, 80, 0.2)", color: "#81c784" }
                : { backgroundColor: "#c8e6c9", color: "#2e7d32" };
        case "delivered":
            return isDark
                ? { backgroundColor: "rgba(33, 150, 243, 0.2)", color: "#90caf9" }
                : { backgroundColor: "#bbdefb", color: "#1565c0" };
        case "open order":
        case "open":
            return isDark
                ? { backgroundColor: "rgba(255, 152, 0, 0.2)", color: "#ffcc80" }
                : { backgroundColor: "#fff9c4", color: "#f57f17" };
        case "canceled":
        case "cancelled":
            return isDark
                ? { backgroundColor: "rgba(244, 67, 54, 0.2)", color: "#ef9a9a" }
                : { backgroundColor: "#ffcdd2", color: "#c62828" };
        default:
            return isDark
                ? { backgroundColor: "rgba(255, 255, 255, 0.08)", color: "#bdbdbd" }
                : { backgroundColor: "#e0e0e0", color: "#424242" };
    }
}
